import React, { useState } from 'react';
import AdDetailsModal from './AdDetailsModal'; 
import axios from 'axios';
import { toast } from 'react-toastify';
import { adsServer } from "../../server";

const TopPerformingAds = ({ ads }) => {
    const [selectedAd, setSelectedAd] = useState(null); 
    const [isModalOpen, setIsModalOpen] = useState(false);

    if (!ads || ads.length === 0) {
        return <p>No ads available.</p>;
    }

    // Extract clicks and impressions from the metrics object
    const getTotalClicks = (ad) => ad.metrics?.clicks.length || 0;
    const getTotalImpressions = (ad) => ad.metrics?.viewedImpressions.length || 0;

    // Sort ads by total engagement (clicks + impressions)
    const sortedAds = [...ads].sort((a, b) => {
        const totalA = getTotalClicks(a) + getTotalImpressions(a);
        const totalB = getTotalClicks(b) + getTotalImpressions(b);
        return totalB - totalA; 
    });

    // Take the top 3 ads based on performance
    const topAds = sortedAds.slice(0, 3);

    // Calculate average clicks and impressions across all ads
    const totalClicks = ads.reduce((acc, ad) => acc + getTotalClicks(ad), 0);
    const totalImpressions = ads.reduce((acc, ad) => acc + getTotalImpressions(ad), 0);
    const averageClicks = totalClicks / ads.length;
    const averageImpressions = totalImpressions / ads.length;

    // Determine the ad with the lowest engagement
    const lowestEngagementAd = sortedAds[sortedAds.length - 1];
    const averageEngagement = { clicks: averageClicks, impressions: averageImpressions };

    const openModal = (ad) => {
        setSelectedAd(ad);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setSelectedAd(null);
        setIsModalOpen(false);
    };

    const handleRerunAd = async (adId) => {
        try {
            await axios.post(
                `${adsServer}/sponsored/rerun-ad`, 
                { adId }, 
                {
                    withCredentials: true, 
                    headers: {
                        'current-profile': sessionStorage.getItem('currentProfile'),
                    }
                }
            );
            toast.success('Ad re-run successfully!');
            closeModal();
        } catch (error) {
            toast.error('Error re-running ad.');
        }
    };

    return (
        <div className="top-performing-ads-container">
            <h3 className="top-performing-ads-title">Top Performing Ads</h3>
            <div className="top-performing-ads-list">
                {topAds.map((ad, index) => {
                    // get the relevant description
                    const description = ad.product?.description 
                        || ad.shop?.description
                        || ad.brand?.description
                        || 'No description available.';
                    
                    // truncate to 50 chars if needed
                    const truncatedDescription = 
                        description.length > 50 
                            ? description.slice(0, 50) + "..." 
                            : description;

                    return (
                        <div key={ad._id} className="top-ad-card">
                            <div className="top-ad-rank">#{index + 1}</div>
                            <div className="top-ad-content">
                                <div className="top-ad-image">
                                    <img
                                        src={
                                            ad.product?.images[0]?.url ||
                                            ad.shop?.avatar?.url ||
                                            ad.brand?.avatarImage?.url ||
                                            'https://via.placeholder.com/150' 
                                        }
                                        alt={ad.product?.name || ad.shop?.name || ad.brand?.name}
                                    />
                                </div>
                                <div className="top-ad-details">
                                    <h4 className="top-ad-name">
                                        {ad.product?.name || ad.shop?.name || ad.brand?.name}
                                    </h4>
                                    <p className="top-ad-description">
                                        {truncatedDescription}
                                    </p>
                                    <div className="top-ad-stats">
                                        <span>Clicks: {getTotalClicks(ad)}</span>
                                        <span>Impressions: {getTotalImpressions(ad)}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="top-ad-ellipsis" onClick={() => openModal(ad)}>
                                &#x2026;
                            </div>
                        </div>
                    );
                })}
            </div>
            {isModalOpen && (
                <AdDetailsModal
                    ad={selectedAd}
                    onClose={closeModal}
                    lowestEngagementAd={lowestEngagementAd}
                    averageEngagement={averageEngagement}
                    onRerunAd={handleRerunAd}
                />
            )}
        </div>
    );
};

export default TopPerformingAds;


